import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a82d45abedae700143d3ae1_1787770188266_7aa0a95d/statute_1786958938273/src/app/dashboard/page.tsx");
